// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-responsive {
  overflow-x: auto;
}

th {
  justify-items: center;
}
th .mat-sort-header-content {
  margin-left: 10%;
}

td {
  text-align: center;
}

.pods-table {
  min-width: 900px;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/pods-list/pods-list.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,qBAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF","sourcesContent":[".table-responsive {\n  overflow-x: auto;\n}\n\nth {\n  justify-items: center;\n\n  .mat-sort-header-content {\n    margin-left: 10%;\n  }\n}\n\ntd {\n  text-align: center;\n}\n\n.pods-table {\n  min-width: 900px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
